import React from 'react';
import {Grid} from '@material-ui/core';
import Product from './Product/Product';
import useStyles from './styles';

//const products=[
    //{id:1, name: 'Shoes', description:'Running shoes',price:'$5', image:'https://images.pexels.com/photos/1280064///pexels-photo-1280064.jpeg?cs=srgb&dl=pexels-ankur-bagai-1280064.jpg&fm=jpg'},
    //{id:2, name: 'Macbook', description:'Apple macbook',price:'$10', image:'https://images.pexels.com/photos/2047905///pexels-photo-2047905.jpeg?cs=srgb&dl=pexels-junior-teixeira-2047905.jpg&fm=jpg'},
//]

const Products = ({products, onAddToCart}) => {

    const classes = useStyles();
    
    if (!products.length) return <p>Cargando...</p>;

    return(   
    <main className={classes.content}>
        <div className={classes.toolbar} />
        <Grid container justify="center" spacing={4}>
                {products.map((product)=>(
                    <Grid item key={product.id} xs={12} sm={6} md={4} lg={3}>

                       <Product product={product} onAddToCart={onAddToCart} />

                    </Grid>
                ))}
        </Grid>
    </main>
    )

}

export default Products;